var cov_1jqi38y8l8 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tabs/Tabs.tsx",
      hash = "c2d9380bb16af0b4fd2b0f90aebf897fb61366af",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tabs/Tabs.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 16
        }
      },
      "2": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "3": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 44
        }
      },
      "4": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 52
        }
      },
      "5": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 56
        }
      },
      "6": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 54
        }
      },
      "7": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 54
        }
      },
      "8": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 58
        }
      },
      "9": {
        start: {
          line: 57,
          column: 44
        },
        end: {
          line: 57,
          column: 54
        }
      },
      "10": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "11": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 41
        }
      },
      "12": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 25
        }
      },
      "13": {
        start: {
          line: 76,
          column: 42
        },
        end: {
          line: 76,
          column: 52
        }
      },
      "14": {
        start: {
          line: 77,
          column: 23
        },
        end: {
          line: 77,
          column: 62
        }
      },
      "15": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 81,
          column: 5
        }
      },
      "16": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 75
        }
      },
      "17": {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 49
        }
      },
      "18": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "19": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 79
        }
      },
      "20": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 49
        }
      },
      "21": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 32
        }
      },
      "22": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 56
        }
      },
      "23": {
        start: {
          line: 92,
          column: 32
        },
        end: {
          line: 92,
          column: 56
        }
      },
      "24": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 28
        }
      },
      "25": {
        start: {
          line: 97,
          column: 36
        },
        end: {
          line: 97,
          column: 46
        }
      },
      "26": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 39
        }
      },
      "27": {
        start: {
          line: 98,
          column: 33
        },
        end: {
          line: 98,
          column: 39
        }
      },
      "28": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 99,
          column: 22
        }
      },
      "29": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 25
        }
      },
      "30": {
        start: {
          line: 107,
          column: 25
        },
        end: {
          line: 107,
          column: 35
        }
      },
      "31": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 34
        }
      },
      "32": {
        start: {
          line: 108,
          column: 18
        },
        end: {
          line: 108,
          column: 34
        }
      },
      "33": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 29
        }
      },
      "34": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 32
        }
      },
      "35": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 127,
          column: 18
        }
      },
      "36": {
        start: {
          line: 128,
          column: 19
        },
        end: {
          line: 128,
          column: 35
        }
      },
      "37": {
        start: {
          line: 129,
          column: 35
        },
        end: {
          line: 129,
          column: 37
        }
      },
      "38": {
        start: {
          line: 131,
          column: 21
        },
        end: {
          line: 131,
          column: 31
        }
      },
      "39": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "40": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 41
        }
      },
      "41": {
        start: {
          line: 134,
          column: 35
        },
        end: {
          line: 134,
          column: 41
        }
      },
      "42": {
        start: {
          line: 136,
          column: 18
        },
        end: {
          line: 136,
          column: 22
        }
      },
      "43": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 142,
          column: 21
        }
      },
      "44": {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 139,
          column: 31
        }
      },
      "45": {
        start: {
          line: 140,
          column: 15
        },
        end: {
          line: 142,
          column: 21
        }
      },
      "46": {
        start: {
          line: 141,
          column: 10
        },
        end: {
          line: 141,
          column: 21
        }
      },
      "47": {
        start: {
          line: 142,
          column: 15
        },
        end: {
          line: 142,
          column: 21
        }
      },
      "48": {
        start: {
          line: 144,
          column: 39
        },
        end: {
          line: 144,
          column: 50
        }
      },
      "49": {
        start: {
          line: 145,
          column: 26
        },
        end: {
          line: 145,
          column: 44
        }
      },
      "50": {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 150,
          column: 9
        }
      },
      "51": {
        start: {
          line: 148,
          column: 10
        },
        end: {
          line: 149,
          column: 35
        }
      },
      "52": {
        start: {
          line: 148,
          column: 27
        },
        end: {
          line: 148,
          column: 47
        }
      },
      "53": {
        start: {
          line: 149,
          column: 15
        },
        end: {
          line: 149,
          column: 35
        }
      },
      "54": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 165,
          column: 10
        }
      },
      "55": {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 181,
          column: 8
        }
      },
      "56": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 204,
          column: 5
        }
      },
      "57": {
        start: {
          line: 185,
          column: 30
        },
        end: {
          line: 185,
          column: 49
        }
      },
      "58": {
        start: {
          line: 186,
          column: 73
        },
        end: {
          line: 189,
          column: 7
        }
      },
      "59": {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 192,
          column: 7
        }
      },
      "60": {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 191,
          column: 32
        }
      },
      "61": {
        start: {
          line: 193,
          column: 6
        },
        end: {
          line: 198,
          column: 7
        }
      },
      "62": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 197,
          column: 9
        }
      },
      "63": {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 203,
          column: 7
        }
      },
      "64": {
        start: {
          line: 205,
          column: 4
        },
        end: {
          line: 205,
          column: 17
        }
      },
      "65": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 209,
          column: 68
        }
      },
      "66": {
        start: {
          line: 209,
          column: 57
        },
        end: {
          line: 209,
          column: 68
        }
      },
      "67": {
        start: {
          line: 210,
          column: 34
        },
        end: {
          line: 210,
          column: 44
        }
      },
      "68": {
        start: {
          line: 211,
          column: 33
        },
        end: {
          line: 211,
          column: 44
        }
      },
      "69": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "70": {
        start: {
          line: 227,
          column: 49
        },
        end: {
          line: 227,
          column: 59
        }
      },
      "71": {
        start: {
          line: 228,
          column: 21
        },
        end: {
          line: 228,
          column: 36
        }
      },
      "72": {
        start: {
          line: 229,
          column: 34
        },
        end: {
          line: 229,
          column: 42
        }
      },
      "73": {
        start: {
          line: 230,
          column: 22
        },
        end: {
          line: 240,
          column: 5
        }
      },
      "74": {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 248,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 35
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 40
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 68
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 56
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 25
          },
          end: {
            line: 73,
            column: 3
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 75,
            column: 13
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 75
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 14
          },
          end: {
            line: 94,
            column: 3
          }
        },
        line: 91
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        },
        loc: {
          start: {
            line: 96,
            column: 33
          },
          end: {
            line: 100,
            column: 3
          }
        },
        line: 96
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 102,
            column: 2
          },
          end: {
            line: 102,
            column: 3
          }
        },
        loc: {
          start: {
            line: 102,
            column: 38
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 102
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        },
        loc: {
          start: {
            line: 106,
            column: 26
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 106
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        loc: {
          start: {
            line: 112,
            column: 37
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 112
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 43
          },
          end: {
            line: 206,
            column: 3
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 133,
            column: 7
          }
        },
        loc: {
          start: {
            line: 133,
            column: 95
          },
          end: {
            line: 166,
            column: 7
          }
        },
        line: 133
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 208,
            column: 2
          },
          end: {
            line: 208,
            column: 3
          }
        },
        loc: {
          start: {
            line: 208,
            column: 104
          },
          end: {
            line: 224,
            column: 3
          }
        },
        line: 208
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 226,
            column: 2
          },
          end: {
            line: 226,
            column: 3
          }
        },
        loc: {
          start: {
            line: 226,
            column: 11
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 226
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 44,
            column: 14
          },
          end: {
            line: 44,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 14
          },
          end: {
            line: 44,
            column: 33
          }
        }, {
          start: {
            line: 44,
            column: 37
          },
          end: {
            line: 44,
            column: 38
          }
        }],
        line: 44
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 64,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 7
          },
          end: {
            line: 60,
            column: 34
          }
        }, {
          start: {
            line: 60,
            column: 38
          },
          end: {
            line: 60,
            column: 76
          }
        }, {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 61,
            column: 20
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 62,
            column: 22
          }
        }, {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 17
          }
        }, {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 64,
            column: 17
          }
        }],
        line: 60
      },
      "3": {
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 28
          }
        }, {
          start: {
            line: 77,
            column: 32
          },
          end: {
            line: 77,
            column: 62
          }
        }],
        line: 77
      },
      "4": {
        loc: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 81,
            column: 5
          }
        }],
        line: 78
      },
      "5": {
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 26
          }
        }, {
          start: {
            line: 78,
            column: 30
          },
          end: {
            line: 78,
            column: 40
          }
        }],
        line: 78
      },
      "6": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 83
      },
      "7": {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 19
          }
        }, {
          start: {
            line: 83,
            column: 23
          },
          end: {
            line: 83,
            column: 33
          }
        }],
        line: 83
      },
      "8": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 56
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 56
          }
        }],
        line: 92
      },
      "9": {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 39
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 39
          }
        }],
        line: 98
      },
      "10": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 15
          }
        }, {
          start: {
            line: 98,
            column: 19
          },
          end: {
            line: 98,
            column: 31
          }
        }],
        line: 98
      },
      "11": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 34
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 34
          }
        }],
        line: 108
      },
      "12": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 41
          }
        }, {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 41
          }
        }],
        line: 134
      },
      "13": {
        loc: {
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 134,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 134,
            column: 18
          }
        }, {
          start: {
            line: 134,
            column: 22
          },
          end: {
            line: 134,
            column: 33
          }
        }],
        line: 134
      },
      "14": {
        loc: {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 142,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 142,
            column: 21
          }
        }, {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 142,
            column: 21
          }
        }],
        line: 137
      },
      "15": {
        loc: {
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 142,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 142,
            column: 21
          }
        }, {
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 142,
            column: 21
          }
        }],
        line: 140
      },
      "16": {
        loc: {
          start: {
            line: 144,
            column: 16
          },
          end: {
            line: 144,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 144,
            column: 21
          },
          end: {
            line: 144,
            column: 22
          }
        }],
        line: 144
      },
      "17": {
        loc: {
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 150,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 150,
            column: 9
          }
        }, {
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 150,
            column: 9
          }
        }],
        line: 147
      },
      "18": {
        loc: {
          start: {
            line: 148,
            column: 10
          },
          end: {
            line: 149,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 10
          },
          end: {
            line: 149,
            column: 35
          }
        }, {
          start: {
            line: 148,
            column: 10
          },
          end: {
            line: 149,
            column: 35
          }
        }],
        line: 148
      },
      "19": {
        loc: {
          start: {
            line: 158,
            column: 22
          },
          end: {
            line: 158,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 22
          },
          end: {
            line: 158,
            column: 32
          }
        }, {
          start: {
            line: 158,
            column: 37
          },
          end: {
            line: 158,
            column: 95
          }
        }],
        line: 158
      },
      "20": {
        loc: {
          start: {
            line: 158,
            column: 37
          },
          end: {
            line: 158,
            column: 95
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 158,
            column: 53
          },
          end: {
            line: 158,
            column: 74
          }
        }, {
          start: {
            line: 158,
            column: 77
          },
          end: {
            line: 158,
            column: 95
          }
        }],
        line: 158
      },
      "21": {
        loc: {
          start: {
            line: 160,
            column: 17
          },
          end: {
            line: 160,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 17
          },
          end: {
            line: 160,
            column: 34
          }
        }, {
          start: {
            line: 160,
            column: 39
          },
          end: {
            line: 160,
            column: 72
          }
        }],
        line: 160
      },
      "22": {
        loc: {
          start: {
            line: 160,
            column: 39
          },
          end: {
            line: 160,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 160,
            column: 55
          },
          end: {
            line: 160,
            column: 60
          }
        }, {
          start: {
            line: 160,
            column: 63
          },
          end: {
            line: 160,
            column: 72
          }
        }],
        line: 160
      },
      "23": {
        loc: {
          start: {
            line: 174,
            column: 20
          },
          end: {
            line: 174,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 34
          },
          end: {
            line: 174,
            column: 53
          }
        }, {
          start: {
            line: 174,
            column: 56
          },
          end: {
            line: 174,
            column: 65
          }
        }],
        line: 174
      },
      "24": {
        loc: {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        }, {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 204,
            column: 5
          }
        }],
        line: 184
      },
      "25": {
        loc: {
          start: {
            line: 184,
            column: 8
          },
          end: {
            line: 184,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 184,
            column: 8
          },
          end: {
            line: 184,
            column: 24
          }
        }, {
          start: {
            line: 184,
            column: 28
          },
          end: {
            line: 184,
            column: 39
          }
        }],
        line: 184
      },
      "26": {
        loc: {
          start: {
            line: 190,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 190,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        }, {
          start: {
            line: 190,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        }],
        line: 190
      },
      "27": {
        loc: {
          start: {
            line: 193,
            column: 6
          },
          end: {
            line: 198,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 6
          },
          end: {
            line: 198,
            column: 7
          }
        }, {
          start: {
            line: 193,
            column: 6
          },
          end: {
            line: 198,
            column: 7
          }
        }],
        line: 193
      },
      "28": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 68
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 68
          }
        }],
        line: 209
      },
      "29": {
        loc: {
          start: {
            line: 209,
            column: 10
          },
          end: {
            line: 209,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 10
          },
          end: {
            line: 209,
            column: 15
          }
        }, {
          start: {
            line: 209,
            column: 19
          },
          end: {
            line: 209,
            column: 29
          }
        }, {
          start: {
            line: 209,
            column: 33
          },
          end: {
            line: 209,
            column: 54
          }
        }],
        line: 209
      },
      "30": {
        loc: {
          start: {
            line: 211,
            column: 12
          },
          end: {
            line: 211,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 211,
            column: 17
          },
          end: {
            line: 211,
            column: 18
          }
        }],
        line: 211
      },
      "31": {
        loc: {
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 233,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 233,
            column: 13
          }
        }, {
          start: {
            line: 233,
            column: 17
          },
          end: {
            line: 233,
            column: 33
          }
        }],
        line: 233
      },
      "32": {
        loc: {
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 234,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 234,
            column: 18
          }
        }, {
          start: {
            line: 234,
            column: 22
          },
          end: {
            line: 234,
            column: 32
          }
        }],
        line: 234
      },
      "33": {
        loc: {
          start: {
            line: 236,
            column: 8
          },
          end: {
            line: 236,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 236,
            column: 8
          },
          end: {
            line: 236,
            column: 16
          }
        }, {
          start: {
            line: 236,
            column: 20
          },
          end: {
            line: 236,
            column: 31
          }
        }],
        line: 236
      },
      "34": {
        loc: {
          start: {
            line: 237,
            column: 8
          },
          end: {
            line: 237,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 237,
            column: 8
          },
          end: {
            line: 237,
            column: 15
          }
        }, {
          start: {
            line: 237,
            column: 19
          },
          end: {
            line: 237,
            column: 24
          }
        }],
        line: 237
      },
      "35": {
        loc: {
          start: {
            line: 244,
            column: 9
          },
          end: {
            line: 244,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 244,
            column: 9
          },
          end: {
            line: 244,
            column: 35
          }
        }, {
          start: {
            line: 244,
            column: 39
          },
          end: {
            line: 244,
            column: 57
          }
        }, {
          start: {
            line: 244,
            column: 61
          },
          end: {
            line: 244,
            column: 88
          }
        }],
        line: 244
      },
      "36": {
        loc: {
          start: {
            line: 246,
            column: 9
          },
          end: {
            line: 246,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 10
          },
          end: {
            line: 246,
            column: 36
          }
        }, {
          start: {
            line: 246,
            column: 40
          },
          end: {
            line: 246,
            column: 58
          }
        }, {
          start: {
            line: 246,
            column: 63
          },
          end: {
            line: 246,
            column: 90
          }
        }],
        line: 246
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0, 0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0, 0],
      "30": [0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0, 0],
      "36": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tabs/Tabs.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Children } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import Header from './Header';
import getDataset from '../utils/dom/getDataset';
import Wrapper from './Wrapper';
import Sticky from '../Sticky';
import { tabsClass } from './styles';
import { isEmpty, isObject } from '../utils/is';
import { isRTL } from '../config';
import Panel from './Panel';
import Link from './Link';
var DefaultValue = (cov_1jqi38y8l8.s[0]++, {
  defaultCollapsed: false,
  lazy: true,
  hideSplit: false
});

var Tabs =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tabs, _PureComponent);

  var _super = _createSuper2(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    cov_1jqi38y8l8.f[0]++;
    cov_1jqi38y8l8.s[1]++;
    _this = _super.call(this, props);
    _this.container = void 0;
    _this.sticky = void 0;
    cov_1jqi38y8l8.s[2]++;
    _this.state = {
      active: (cov_1jqi38y8l8.b[0][0]++, props.defaultActive) || (cov_1jqi38y8l8.b[0][1]++, 0),
      collapsed: props.defaultCollapsed
    };
    cov_1jqi38y8l8.s[3]++;
    _this.getAlign = _this.getAlign.bind(_assertThisInitialized(_this));
    cov_1jqi38y8l8.s[4]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_1jqi38y8l8.s[5]++;
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_this));
    cov_1jqi38y8l8.s[6]++;
    _this.renderContent = _this.renderContent.bind(_assertThisInitialized(_this));
    cov_1jqi38y8l8.s[7]++;
    _this.bindContainer = _this.bindContainer.bind(_assertThisInitialized(_this));
    cov_1jqi38y8l8.s[8]++;
    _this.setStickyStatus = _this.setStickyStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      cov_1jqi38y8l8.f[1]++;

      var _ref = (cov_1jqi38y8l8.s[9]++, this.props),
          sticky = _ref.sticky,
          switchToTop = _ref.switchToTop,
          active = _ref.active;

      cov_1jqi38y8l8.s[10]++;

      if (((cov_1jqi38y8l8.b[2][0]++, prevProps.active !== active) || (cov_1jqi38y8l8.b[2][1]++, prevState.active !== this.state.active)) && (cov_1jqi38y8l8.b[2][2]++, this.container) && (cov_1jqi38y8l8.b[2][3]++, !isEmpty(sticky)) && (cov_1jqi38y8l8.b[2][4]++, switchToTop) && (cov_1jqi38y8l8.b[2][5]++, this.sticky)) {
        cov_1jqi38y8l8.b[1][0]++;
        cov_1jqi38y8l8.s[11]++;
        // jump to active panel
        this.container.scrollIntoView(true);
      } else {
        cov_1jqi38y8l8.b[1][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1jqi38y8l8.f[2]++;
      cov_1jqi38y8l8.s[12]++;
      this.container = null;
    }
  }, {
    key: "getAlign",
    value: function getAlign() {
      cov_1jqi38y8l8.f[3]++;

      var _ref2 = (cov_1jqi38y8l8.s[13]++, this.props),
          shape = _ref2.shape,
          collapsible = _ref2.collapsible,
          align = _ref2.align;

      var isVertical = (cov_1jqi38y8l8.s[14]++, (cov_1jqi38y8l8.b[3][0]++, align) && (cov_1jqi38y8l8.b[3][1]++, align.indexOf('vertical') > -1));
      cov_1jqi38y8l8.s[15]++;

      if ((cov_1jqi38y8l8.b[5][0]++, shape === 'button') && (cov_1jqi38y8l8.b[5][1]++, isVertical)) {
        cov_1jqi38y8l8.b[4][0]++;
        cov_1jqi38y8l8.s[16]++;
        console.warn("align vertical-* can't supported when shape is button");
        cov_1jqi38y8l8.s[17]++;
        return {
          align: 'left',
          isVertical: false
        };
      } else {
        cov_1jqi38y8l8.b[4][1]++;
      }

      cov_1jqi38y8l8.s[18]++;

      if ((cov_1jqi38y8l8.b[7][0]++, collapsible) && (cov_1jqi38y8l8.b[7][1]++, isVertical)) {
        cov_1jqi38y8l8.b[6][0]++;
        cov_1jqi38y8l8.s[19]++;
        console.warn("align vertical-* can't supported when collapsible is true");
        cov_1jqi38y8l8.s[20]++;
        return {
          align: 'left',
          isVertical: false
        };
      } else {
        cov_1jqi38y8l8.b[6][1]++;
      }

      cov_1jqi38y8l8.s[21]++;
      return {
        align: align,
        isVertical: isVertical
      };
    }
  }, {
    key: "getActive",
    value: function getActive() {
      cov_1jqi38y8l8.f[4]++;
      cov_1jqi38y8l8.s[22]++;

      if ('active' in this.props) {
        cov_1jqi38y8l8.b[8][0]++;
        cov_1jqi38y8l8.s[23]++;
        return this.props.active;
      } else {
        cov_1jqi38y8l8.b[8][1]++;
      }

      cov_1jqi38y8l8.s[24]++;
      return this.state.active;
    }
  }, {
    key: "setStickyStatus",
    value: function setStickyStatus(flag) {
      cov_1jqi38y8l8.f[5]++;

      var _ref3 = (cov_1jqi38y8l8.s[25]++, this.props),
          sticky = _ref3.sticky,
          switchToTop = _ref3.switchToTop;

      cov_1jqi38y8l8.s[26]++;

      if ((cov_1jqi38y8l8.b[10][0]++, !sticky) || (cov_1jqi38y8l8.b[10][1]++, !switchToTop)) {
        cov_1jqi38y8l8.b[9][0]++;
        cov_1jqi38y8l8.s[27]++;
        return;
      } else {
        cov_1jqi38y8l8.b[9][1]++;
      }

      cov_1jqi38y8l8.s[28]++;
      this.sticky = flag;
    }
  }, {
    key: "bindContainer",
    value: function bindContainer(node) {
      cov_1jqi38y8l8.f[6]++;
      cov_1jqi38y8l8.s[29]++;
      this.container = node;
    }
  }, {
    key: "handleChange",
    value: function handleChange(active) {
      cov_1jqi38y8l8.f[7]++;

      var _ref4 = (cov_1jqi38y8l8.s[30]++, this.props),
          onChange = _ref4.onChange;

      cov_1jqi38y8l8.s[31]++;

      if (onChange) {
        cov_1jqi38y8l8.b[11][0]++;
        cov_1jqi38y8l8.s[32]++;
        onChange(active);
      } else {
        cov_1jqi38y8l8.b[11][1]++;
      }

      cov_1jqi38y8l8.s[33]++;
      this.setState({
        active: active
      });
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse(collapsed) {
      cov_1jqi38y8l8.f[8]++;
      cov_1jqi38y8l8.s[34]++;
      this.setState({
        collapsed: collapsed
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(_ref5) {
      var _this2 = this;

      var align = _ref5.align,
          isVertical = _ref5.isVertical;
      cov_1jqi38y8l8.f[9]++;

      var _ref6 = (cov_1jqi38y8l8.s[35]++, this.props),
          children = _ref6.children,
          color = _ref6.color,
          shape = _ref6.shape,
          tabBarStyle = _ref6.tabBarStyle,
          inactiveBackground = _ref6.inactiveBackground,
          collapsible = _ref6.collapsible,
          tabBarExtraContent = _ref6.tabBarExtraContent,
          sticky = _ref6.sticky,
          hideSplit = _ref6.hideSplit;

      var active = (cov_1jqi38y8l8.s[36]++, this.getActive());
      var tabs = (cov_1jqi38y8l8.s[37]++, []);

      var _ref7 = (cov_1jqi38y8l8.s[38]++, this.props),
          border = _ref7.border;

      cov_1jqi38y8l8.s[39]++;
      Children.toArray(children).forEach(function (child, i, arr) {
        cov_1jqi38y8l8.f[10]++;
        cov_1jqi38y8l8.s[40]++;

        if ((cov_1jqi38y8l8.b[13][0]++, !child) || (cov_1jqi38y8l8.b[13][1]++, !child.type)) {
          cov_1jqi38y8l8.b[12][0]++;
          cov_1jqi38y8l8.s[41]++;
          return;
        } else {
          cov_1jqi38y8l8.b[12][1]++;
        }

        var tab = (cov_1jqi38y8l8.s[42]++, null);
        cov_1jqi38y8l8.s[43]++;

        if (child.type.isTabPanel) {
          cov_1jqi38y8l8.b[14][0]++;
          cov_1jqi38y8l8.s[44]++;
          // eslint-disable-next-line
          tab = child.props.tab;
        } else {
          cov_1jqi38y8l8.b[14][1]++;
          cov_1jqi38y8l8.s[45]++;

          if (child.type.isTabLink) {
            cov_1jqi38y8l8.b[15][0]++;
            cov_1jqi38y8l8.s[46]++;
            tab = child;
          } else {
            cov_1jqi38y8l8.b[15][1]++;
            cov_1jqi38y8l8.s[47]++;
            return;
          }
        }

        var _ref8 = (cov_1jqi38y8l8.s[48]++, child.props),
            _ref8$id = _ref8.id,
            id = _ref8$id === void 0 ? (cov_1jqi38y8l8.b[16][0]++, i) : _ref8$id,
            background = _ref8.background;

        var childBorder = (cov_1jqi38y8l8.s[49]++, child.props.border); // eslint-disable-next-line

        cov_1jqi38y8l8.s[50]++;

        if (active === id) {
          cov_1jqi38y8l8.b[17][0]++;
          cov_1jqi38y8l8.s[51]++;

          if (childBorder) {
            cov_1jqi38y8l8.b[18][0]++;
            cov_1jqi38y8l8.s[52]++;
            border = childBorder;
          } else {
            cov_1jqi38y8l8.b[18][1]++;
            cov_1jqi38y8l8.s[53]++;
            childBorder = border;
          }
        } else {
          cov_1jqi38y8l8.b[17][1]++;
        }

        cov_1jqi38y8l8.s[54]++;
        tabs.push(_objectSpread2({
          id: id,
          isActive: active === id,
          tab: tab,
          isVertical: isVertical,
          align: align,
          background: (cov_1jqi38y8l8.b[19][0]++, background) || (cov_1jqi38y8l8.b[19][1]++, active === id ? (cov_1jqi38y8l8.b[20][0]++, _this2.props.background) : (cov_1jqi38y8l8.b[20][1]++, inactiveBackground)),
          border: childBorder,
          color: (cov_1jqi38y8l8.b[21][0]++, child.props.color) || (cov_1jqi38y8l8.b[21][1]++, active === id ? (cov_1jqi38y8l8.b[22][0]++, color) : (cov_1jqi38y8l8.b[22][1]++, undefined)),
          disabled: child.props.disabled,
          shape: shape,
          last: arr.length - 1 === i
        }, getDataset(child.props)));
      });
      var header = (cov_1jqi38y8l8.s[55]++,
      /*#__PURE__*/
      React.createElement(Header, {
        isVertical: isVertical,
        border: border,
        collapsed: this.state.collapsed,
        onCollapse: collapsible ? (cov_1jqi38y8l8.b[23][0]++, this.handleCollapse) : (cov_1jqi38y8l8.b[23][1]++, undefined),
        shape: shape,
        onChange: this.handleChange,
        tabs: tabs,
        tabBarExtraContent: tabBarExtraContent,
        tabBarStyle: tabBarStyle,
        hideSplit: hideSplit,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 170,
          columnNumber: 7
        }
      }));
      cov_1jqi38y8l8.s[56]++;

      if ((cov_1jqi38y8l8.b[25][0]++, !isEmpty(sticky)) && (cov_1jqi38y8l8.b[25][1]++, !isVertical)) {
        cov_1jqi38y8l8.b[24][0]++;
        var stickyClassName = (cov_1jqi38y8l8.s[57]++, tabsClass('sticky'));
        var stickyProps = (cov_1jqi38y8l8.s[58]++, {
          top: 0,
          className: stickyClassName
        });
        cov_1jqi38y8l8.s[59]++;

        if (typeof sticky === 'number') {
          cov_1jqi38y8l8.b[26][0]++;
          cov_1jqi38y8l8.s[60]++;
          stickyProps.top = sticky;
        } else {
          cov_1jqi38y8l8.b[26][1]++;
        }

        cov_1jqi38y8l8.s[61]++;

        if (isObject(sticky)) {
          cov_1jqi38y8l8.b[27][0]++;
          cov_1jqi38y8l8.s[62]++;
          stickyProps = _objectSpread2(_objectSpread2({}, sticky), {}, {
            className: classnames(stickyClassName, sticky.className)
          });
        } else {
          cov_1jqi38y8l8.b[27][1]++;
        }

        cov_1jqi38y8l8.s[63]++;
        return (
          /*#__PURE__*/
          React.createElement(Sticky, Object.assign({
            onChange: this.setStickyStatus
          }, stickyProps, {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 200,
              columnNumber: 9
            }
          }), header)
        );
      } else {
        cov_1jqi38y8l8.b[24][1]++;
      }

      cov_1jqi38y8l8.s[64]++;
      return header;
    }
  }, {
    key: "renderContent",
    value: function renderContent(child, i) {
      cov_1jqi38y8l8.f[11]++;
      cov_1jqi38y8l8.s[65]++;

      if (!((cov_1jqi38y8l8.b[29][0]++, child) && (cov_1jqi38y8l8.b[29][1]++, child.type) && (cov_1jqi38y8l8.b[29][2]++, child.type.isTabPanel))) {
        cov_1jqi38y8l8.b[28][0]++;
        cov_1jqi38y8l8.s[66]++;
        return null;
      } else {
        cov_1jqi38y8l8.b[28][1]++;
      }

      var _ref9 = (cov_1jqi38y8l8.s[67]++, this.props),
          collapsible = _ref9.collapsible,
          lazy = _ref9.lazy;

      var _ref10 = (cov_1jqi38y8l8.s[68]++, child.props),
          _ref10$id = _ref10.id,
          id = _ref10$id === void 0 ? (cov_1jqi38y8l8.b[30][0]++, i) : _ref10$id,
          other = _objectWithoutProperties(_ref10, ["id"]);

      cov_1jqi38y8l8.s[69]++;
      return (
        /*#__PURE__*/
        React.createElement(Wrapper, Object.assign({}, other, {
          lazy: lazy,
          collapsed: this.state.collapsed,
          collapsible: collapsible,
          id: id,
          key: id,
          active: this.getActive(),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 214,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1jqi38y8l8.f[12]++;

      var _ref11 = (cov_1jqi38y8l8.s[70]++, this.props),
          children = _ref11.children,
          shape = _ref11.shape,
          style = _ref11.style,
          autoFill = _ref11.autoFill;

      var position = (cov_1jqi38y8l8.s[71]++, this.getAlign());

      var _ref12 = (cov_1jqi38y8l8.s[72]++, position),
          align = _ref12.align,
          isVertical = _ref12.isVertical;

      var className = (cov_1jqi38y8l8.s[73]++, classnames(tabsClass('_', (cov_1jqi38y8l8.b[31][0]++, align) && (cov_1jqi38y8l8.b[31][1]++, "align-".concat(align)), (cov_1jqi38y8l8.b[32][0]++, isVertical) && (cov_1jqi38y8l8.b[32][1]++, 'vertical'), shape, (cov_1jqi38y8l8.b[33][0]++, autoFill) && (cov_1jqi38y8l8.b[33][1]++, 'auto-fill'), (cov_1jqi38y8l8.b[34][0]++, isRTL()) && (cov_1jqi38y8l8.b[34][1]++, 'rtl')), this.props.className));
      cov_1jqi38y8l8.s[74]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style,
          ref: this.bindContainer,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 243,
            columnNumber: 7
          }
        }, (cov_1jqi38y8l8.b[35][0]++, align !== 'vertical-right') && (cov_1jqi38y8l8.b[35][1]++, align !== 'bottom') && (cov_1jqi38y8l8.b[35][2]++, this.renderHeader(position)), Children.toArray(children).map(this.renderContent), ((cov_1jqi38y8l8.b[36][0]++, align === 'vertical-right') || (cov_1jqi38y8l8.b[36][1]++, align === 'bottom')) && (cov_1jqi38y8l8.b[36][2]++, this.renderHeader(position)))
      );
    }
  }]);

  return Tabs;
}(PureComponent);

Tabs.defaultProps = DefaultValue;
Tabs.Panel = Panel;
Tabs.Link = Link;
Tabs.displayName = void 0;
export default Tabs;